module.exports = __webpack_public_path__ + "static/media/hongkonglog.abbacff9.png";